import { makeListGroupsComponent } from '../ListGroups';
import { DeviceListData } from '../../types/device';

export const DeviceListGroups = makeListGroupsComponent<DeviceListData>();
